// extracted by mini-css-extract-plugin
export default {"input":"Input_input__A-zB2","block":"Input_block__WL8z1","small":"Input_small__HH4sg","medium":"Input_medium__jsXko"};